import { useMatchaMetaEligibility } from '@/hooks/useMatchaMetaEligibility';
import { useMatchaWallets } from '@/hooks/useMatchaWallets';

import { ArrowUpRightIcon } from '@/ui/Icons/ArrowUpRightIcon';

export const MatchaMetaLink = () => {
  const { ethereumWallet } = useMatchaWallets();
  const { data: matchaMetaEligibility } = useMatchaMetaEligibility(ethereumWallet?.address);

  if (!matchaMetaEligibility?.isEligible) {
    return null;
  }

  return (
    <p>
      Need a zero fee option? Try{' '}
      <a
        className="inline-flex items-center text-token-purple-900 hover:underline active:underline"
        href="https://meta.matcha.xyz"
        target="_blank"
        rel="noreferrer"
      >
        Matcha Meta
        <ArrowUpRightIcon className="ml-0.5 size-3" aria-hidden />
      </a>
    </p>
  );
};
